import { Link } from "react-router-dom";
import { Badge } from "@/components/ui/Badge";
import type { SubscriptionWithPlanName } from "@/features/dashboard/api";

interface AccountSummaryCardProps {
  subscription: SubscriptionWithPlanName | null;
}

const PREMIUM_PLAN_NAMES = new Set(["Elite"]);

export function AccountSummaryCard({ subscription }: AccountSummaryCardProps) {
  const planName = subscription?.plans?.name ?? "Free";
  const isPremium = PREMIUM_PLAN_NAMES.has(planName);

  return (
    <div className="account-summary-card">
      <div className="kv-row">
        <span>Plan</span>
        <Badge tone={isPremium ? "premium" : "neutral"}>{planName}</Badge>
      </div>
      {subscription?.current_period_end ? (
        <div className="kv-row">
          <span>Renews</span>
          <span className="font-numeric">
            {new Date(subscription.current_period_end).toLocaleDateString()}
          </span>
        </div>
      ) : null}
      <Link to="/profile" onClick={(event) => event.stopPropagation()} className="btn btn-ghost btn-sm account-summary-card-link">
        Manage →
      </Link>
    </div>
  );
}
